(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4800],{

/***/ 73276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop",
      function () {
        return __webpack_require__(19315);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55847);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63896);
/* harmony import */ var _containers_Shop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78383);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);








var ShopPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name).concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.address) === null || ref1 === void 0 ? void 0 : ref1.city) ? Boolean((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.address) === null || ref2 === void 0 ? void 0 : ref2.visibility) === 1) ? ", ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.address) === null || ref3 === void 0 ? void 0 : ref3.city) : "" : "", " - Order Online"),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.logo_image,
        metaDescription: storeInfo && (0,_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__/* .getMetaDescription */ .w)(storeInfo),
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Shop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,2024,6379,4814,7856,9228,6576,1207,3896,537,1242,2031,6860,3973,9875,261,7909,5740,5650,4640,155,5684,3073,9774,2888,179], function() { return __webpack_exec__(73276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);